import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { PartLabelDisplay } from "../models/LabelDisplay";
import { DefaultResponseWithData } from "../models/system";

export const partLabelDisplayQueryKey = ["label", "display"] as const;

export const partLabelDisplayStaleTimeMs = 1000 * 60 * 60; // 1 hour

export default function usePartLabels() {
  const { get } = useApiHelper();

  const labelDisplay = useQuery(
    partLabelDisplayQueryKey,
    () => get<DefaultResponseWithData<PartLabelDisplay>>(`/template/label/display`),
    { staleTime: partLabelDisplayStaleTimeMs }
  );

  return { labelDisplay };
}
